import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { KeycloakAuthGuard, KeycloakService } from 'keycloak-angular';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard extends KeycloakAuthGuard {
  constructor(
    protected override readonly router: Router,
    protected readonly keycloak: KeycloakService,
  ) {
    super(router, keycloak);
  }

  public async isAccessAllowed(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ) {
    if (!this.authenticated) {
      // ===== DÉBUT MODIF : revenir sur la page demandée après la connexion =====
      // origin + pathname = « https://test-fode.force-n.sn/fode/ » (ou « http://localhost:4200/ » en local)
      // state.url = « /dashboard/agenda/apprenant?activite=123 » : la route ET ses paramètres
      await this.keycloak.login({
        redirectUri:
          window.location.origin + window.location.pathname + '#' + state.url,
      });
      return false; // la page part vers Keycloak : on ne laisse pas passer en attendant
      // ===== FIN MODIF =====
    }

    // Get the roles required from the route.
    const requiredRoles = route.data['roles'];

    // Allow the user to to proceed if no additional roles are required to access the route.
    if (!(requiredRoles instanceof Array) || requiredRoles.length === 0) {
      return true;
    } else {
      return false;
    }
  }
}
